import { useRef } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function BrandAssetCard({ assetKey, title, hint, url, onChange, wide = false }) {
  const ref = useRef();
  const upload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/admin/brand/${assetKey}`, fd); toast.success(`${title} updated — refresh the site to see it`); onChange(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); }
    finally { if (ref.current) ref.current.value = ""; }
  };
  const clear = async () => { await api.delete(`/admin/brand/${assetKey}`); toast.success(`${title} removed`); onChange(); };
  return (
    <div className="dg-card rounded-xl p-5 flex flex-wrap items-center gap-5" data-testid={`brand-card-${assetKey}`}>
      <div className={`${wide ? "w-24 h-24" : "w-16 h-16"} rounded-lg bg-slate-900 border border-slate-700 grid place-items-center overflow-hidden`}>
        {url ? <img src={`${BASE}${url}`} alt={title} className="w-full h-full object-contain" data-testid={`admin-${assetKey}-preview`} />
             : <span className="text-[10px] text-slate-500 font-mono">NONE</span>}
      </div>
      <div className="flex-1 min-w-[200px]">
        <div className="dg-eyebrow">{title}</div>
        <p className="text-sm text-slate-400 mt-1">{hint}</p>
      </div>
      <label className="dg-btn-primary rounded-full px-4 py-2 text-sm cursor-pointer flex items-center gap-2">
        <Upload className="w-4 h-4" /> Upload {title.toLowerCase()}
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${assetKey}-file-input`} />
      </label>
      {url && <button onClick={clear} className="dg-btn-ghost rounded-full px-4 py-2 text-sm" data-testid={`${assetKey}-clear-btn`}>Remove</button>}
    </div>
  );
}
